const modules = import.meta.glob('@/views/**/*.vue')  // 导入

let convert = function (res) {
    let routers = [];
    let parents = res.filter(x => x.parentId == 0);
    for (let i = 0; i < parents.length; i++) {
        let data = parents[i];
        let router = generate(data, `/:corpId`);
        routers.push(router);
        recursion(router, res, 0);
    }
    return routers;
}

function recursion(currRouter, res, depth) {
    currRouter.children = [];
    let children = res.filter(x => x.parentId == currRouter.meta.id);
    if (children.length > 0) {
        for (let z = 0; z < children.length; z++) {
            let child = children[z];
            let subRouter = generate(child, `${currRouter.path}`);
            if (!subRouter)
                continue;
            currRouter.children.push(subRouter);
            recursion(subRouter, res, ++depth);
        }
    }
}

function generate(data, prefixPath) {
    let route = data;
    let routerPath = `${prefixPath}/${route.name}`;
    let componentPath = route.component.replace('@/views/', '');

    if (!componentPath)
        return;
    
    componentPath = '@/views/' + componentPath;
    let router = {
        path: routerPath,
        name: route.name,
        meta: {
            id: route.id,
            code: route.code,
            title: `${route.title}`,
            subtitle: `${route.subTitle}`,
            icon: `${route.icon}`,
            isShow: `${route.isDisplay}`,
            keepalive: false
        },
        component: modules[componentPath.replace('@', '/src')]
    };
    
    return router;
}

export default {
    convert: convert
}